import {textStylesSelector} from "./textStyleSelector";
export const getGridItems = (componentData) => {

    const {titleStyle} = textStylesSelector(componentData);
    
    return {
        elements: componentData?.fields?.elements,
        bgColor: componentData?.fields?.backgroundColour,
        title: componentData?.fields?.title,
        gridColumns: componentData?.fields?.gridColumns,
        gridSpacing: componentData?.fields?.gridSpacing,
        titleStyle: {...titleStyle?.fields}
    };
};
